import React, { Component } from 'react'
import {
    Link,
    Redirect
} from 'react-router-dom'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"
import TemplateSelector from "../../common/template/selection.component.jsx";

class TemplateEditForm extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            id: '',
            name: '',
            status: 'disabled',
            deleteButton: '',
            fromDocumentId: '',
            documentType: this.props.documentType || 'quote-template'
        }

        this.submit = this.submit.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.remove = this.remove.bind(this)
    }

    componentDidMount() {
        const doc = this.props.value
        if (doc && doc.id) {
            const deleteButton = <ConfirmButton identifier={doc.attributes.name} onClick={this.remove} className="btn btn-danger">
                <FormattedMessage
                    id="templates.form.edit.delete_btn"
                    defaultMessage="Delete template"
                />
            </ConfirmButton>
            this.setState({
                id: doc.id,
                name: doc.attributes.name,
                status: doc.attributes.status,
                deleteButton: deleteButton,
                documentType: doc.attributes.type,
            })
        }

    }

    remove(event) {
        AppContext.getApiClient().delete('/documents/' + this.state.id).then((response) => {
            if (!response.error) {
                this.setState({ formStatus: <Redirect to={{ pathname: '/templates/' + this.state.documentType + '/listing' }} /> })
            }
        })
        event.preventDefault()
    }

    save() {
        const doc = this.props.value
        if (doc && doc.id) {
            let updates = {}
            const allowedFields = [
                "name",
                "status",
            ]
            for (let i = 0; i < allowedFields.length; i++) {
                let field = allowedFields[i]
                if (doc.attributes[field] != this.state[field]) {
                    updates[field] = this.state[field]
                }
            }
            return AppContext.getApiClient().patch('/documents/' + doc.id, updates)
        } else {
            return AppContext.getApiClient().post('/documents', {
                "name": this.state.name,
                "status": this.state.status,
                "type": this.state.documentType,
                "fromDocumentId": this.state.fromDocumentId,
            })
        }
    }

    submit(event) {
        this.save().then(res => {
            if (!res.error) {
                this.setState({ formStatus: <Redirect to={{ pathname: '/templates/' + this.state.documentType + '/listing' }} /> })
            }
        })
        event.preventDefault()
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    render() {
        const messages = defineMessages({
            "template_name_placeholder": {
                id: 'templates.form.edit.name_placeholder',
                defaultMessage: 'Internal name of the template',
            },
            "snippet_name_placeholder": {
                id: 'templates.form.edit.snippet_name_placeholder',
                defaultMessage: 'Internal name of the snippet',
            },
            "templates.form.edit.status_disabled_label": {
                id: 'templates.form.edit.status_disabled_label',
                defaultMessage: 'Disabled',
            },
            "templates.form.edit.status_enabled_label": {
                id: 'templates.form.edit.status_enabled_label',
                defaultMessage: 'Enabled',
            },
        })

        let placeholder = ''
        let description = ''
        switch (this.state.documentType) {
            case "quote-template":
            case "order-template":
            case "invoice-template":
                placeholder = this.props.intl.formatMessage(messages['template_name_placeholder'])
                description = <FormattedMessage
                    id="templates.form.edit.name_description"
                    defaultMessage="Internal name of the template"
                />
                break
            case "snippet":
                placeholder = this.props.intl.formatMessage(messages['snippet_name_placeholder'])
                description = <FormattedMessage
                    id="templates.form.edit.snippet_name_description"
                    defaultMessage="Internal name of the snippet"
                />
                break
        }

        return (
            <form onSubmit={this.submit}>
                {this.state.formStatus}
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="name">
                                <FormattedMessage
                                    id="templates.form.edit.name_label"
                                    defaultMessage="Name"
                                />
                            </label>
                            <div className="col-10">
                                <input
                                    name="name"
                                    value={this.state.name}
                                    onChange={this.handleFormChange}
                                    id="name"
                                    type="text"
                                    className="form-control"
                                    placeholder={placeholder}
                                />
                                <small className="form-text text-muted">
                                    {description}
                                </small>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="status">
                                <FormattedMessage
                                    id="templates.form.edit.status_label"
                                    defaultMessage="Status"
                                />
                            </label>
                            <div className="col-10">
                                <select
                                    name="status"
                                    value={this.state.status === "default" ? "enabled" : this.state.status}
                                    onChange={this.handleFormChange}
                                    id="status"
                                    className="form-control"
                                    disabled={this.state.status === "default"}
                                >
                                    <option value="disabled">
                                        {this.props.intl.formatMessage(messages['templates.form.edit.status_disabled_label'])}
                                    </option>
                                    <option value="enabled">
                                        {this.props.intl.formatMessage(messages['templates.form.edit.status_enabled_label'])}
                                    </option>
                                </select>
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="templates.form.edit.status_description"
                                        defaultMessage="Makes it available to choose when making a new quote"
                                    />
                                </small>
                            </div>
                        </div>
                        {!this.props.value ? <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="fromDocumentId">
                                <FormattedMessage
                                    id="templates.form.edit.from_document_label"
                                    defaultMessage="Copy from"
                                />
                            </label>
                            <div className="col-10">
                                <TemplateSelector
                                    documentType={this.state.documentType}
                                    value={this.state.fromDocumentId}
                                    onChange={val => this.setState({ fromDocumentId: val })}
                                />
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="templates.form.edit.from_document_description"
                                        defaultMessage="Start a copy from this document"
                                    />
                                </small>
                            </div>
                        </div> : ''}
                    </div>
                    <div className="col-12 ui-module">
                        <div className="row">
                            <div className="col-6">
                                {this.state.status !== "default" ? this.state.deleteButton : ''}
                            </div>
                            <div className="col-6 text-align-right">
                                <Link to={"/templates/" + this.state.documentType + "/listing"} className="btn btn-light">
                                    <FormattedMessage
                                        id="templates.form.edit.cancel_btn"
                                        defaultMessage="Cancel"
                                    />
                                </Link>
                                &nbsp;
                                &nbsp;
                                <button type="submit" className="btn btn-primary">
                                    <FormattedMessage
                                        id="templates.form.edit.save_btn"
                                        defaultMessage="Save"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default injectIntl(TemplateEditForm)


// WEBPACK FOOTER //
// ./src/template/form/edit.component.jsx